import { connect } from 'react-redux';
import { getUserConfiguration } from './../reducers/profile';
import { updateUserConfiguration } from './../actions/profile.js';
import ThemeToggleComponent from './../Components/ThemeToggleComponent.jsx';

export const mapStateToProps = (state) => {
  return { userConfiguration: getUserConfiguration(state) };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onClick: async (userConfiguration) => {
      userConfiguration.darkMode = !userConfiguration.darkMode;
      await dispatch(updateUserConfiguration(userConfiguration));
      window.location.reload();
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThemeToggleComponent);


// WEBPACK FOOTER //
// src/Containers/ThemeToggleContainer.jsx